/**
 * Contract lifecycle statuses (`contracts.status`).
 *
 * Text column (no Postgres enum / CHECK). Canonical set lives in the
 * e-signature store + Meridian list_contracts filter — keep both derived from
 * this tuple so filter/UI/webhook mapping cannot drift.
 */

export const CONTRACT_STATUS_VALUES = [
  "draft",
  "sent",
  "viewed",
  "partially_signed",
  "signed",
  "declined",
  "withdrawn",
  "error",
] as const;

export type ContractStatus = (typeof CONTRACT_STATUS_VALUES)[number];
